import {TimingProvider} from "context/TimingContext";
import {Outlet} from "react-router-dom";
import {FooterVariant} from "ui/blocks/FooterVariant/FooterVariant";
import {HeaderVariant} from "ui/blocks/HeaderVariant/HeaderVariant";
import {ScrollToTop} from "ui/base/ScrollToTop";

export const UserLayout = () => {
    return (
        <ScrollToTop>
            <TimingProvider>
                <HeaderVariant/>
                <Outlet/>
                <FooterVariant/>
            </TimingProvider>
        </ScrollToTop>
    );
};
